import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#FDF8F3] px-4 py-12 lg:py-20" data-id="element-35">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#C4703F]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-36" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#8B9E7E]/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-37" />

      <div className="container max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-38">
        <div className="space-y-8 text-center lg:text-left" data-id="element-39">
          <FadeIn delay={0.1} data-id="element-40">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#C4703F]/10 text-[#C4703F] text-sm font-medium tracking-wide mb-4" data-id="element-41">
              NUEVO KIT DIGITAL
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] text-[#3D3229] mb-6" data-id="element-42">
              Recuperá tu calma en solo 5 minutos al día
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-43">
            <p className="text-lg md:text-xl text-[#3D3229]/80 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-44">
              Un kit simple para ordenar tu mente en 7 días, con audios y guía
              paso a paso.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-45">
            <button onClick={scrollToPricing} className="group inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white transition-all duration-300 bg-[#C4703F] rounded-full hover:bg-[#A65D33] hover:shadow-lg hover:shadow-[#C4703F]/20 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C4703F]" data-id="element-46">
              Descargalo ahora
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-47" />
            </button>
            <p className="mt-4 text-sm text-[#3D3229]/60" data-id="element-48">
              Acceso inmediato • Garantía de 7 días
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.2} direction="left" className="relative" data-id="element-49">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#3D3229]/10 aspect-[4/5] lg:aspect-square" data-id="element-50">
            <div className="absolute inset-0 bg-gradient-to-t from-[#3D3229]/20 to-transparent z-10" data-id="element-51" />
            <img src="https://cdn.magicpatterns.com/uploads/6jbCqQvAyYBrwUZk54CyC9/heylloyd-image-1770571725629.png" alt="Mujer escribiendo en su diario con luz cálida del atardecer" className="object-cover w-full h-full transform transition-transform duration-700 hover:scale-105" data-id="element-52" />
          </div>
          {/* Decorative floating card */}
          <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl z-20 max-w-[200px] hidden md:block" data-id="element-53">
            <div className="flex items-center gap-3 mb-2" data-id="element-54">
              <div className="w-3 h-3 rounded-full bg-[#8B9E7E]" data-id="element-55" />
              <div className="h-2 w-20 bg-gray-100 rounded-full" data-id="element-56" />
            </div>
            <div className="space-y-2" data-id="element-57">
              <div className="h-2 w-full bg-gray-50 rounded-full" data-id="element-58" />
              <div className="h-2 w-3/4 bg-gray-50 rounded-full" data-id="element-59" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}